export interface TermsResponse {
    /** Zero-padded "yyyy.MM.dd". */
    version: string,
    effectiveDate: string,
    /**
     * Body-level HTML per two-letter language code, for every language this version ships in.
     *
     * Deliberately not resolved to one language server-side the way patch notes are: each
     * language version of the terms is independently binding, so the modal offers its own
     * switch and the reader chooses which one to read. Which codes arrive is the server's
     * call — see `TermsProvider.OfferedLanguages` — so read it defensively rather than
     * assuming both are present.
     */
    bodies: Record<string, string>,
    /** True when this user has already accepted this exact version. */
    isAccepted: boolean,
}

export interface AcceptTermsResponse {
    version: string,
    acceptedAtUtc: string,
}

export interface TermsSliceModel {
    current: TermsResponse | null,
    isLoading: boolean,
    /** Set while the accept request is in flight, so the confirm button can't be double-fired. */
    isAccepting: boolean,
    /**
     * Non-empty when loading failed. The modal shows a retry rather than leaving the user
     * stuck behind a blocking dialog with nothing in it.
     */
    loadError: string,
    /**
     * Non-empty when the accept request failed. Distinct from loadError: the text is there,
     * the write is what went wrong, so the user can simply press confirm again.
     */
    acceptError: string,
}

export const termsInitialValue: TermsSliceModel = {
    current: null,
    isLoading: false,
    isAccepting: false,
    loadError: '',
    acceptError: '',
};
